// Mock data for EOS Elektro-Unternehmen
export const mockData = {
  company: {
    name: 'EOS Energy Systems GmbH',
    fullName: 'EOS Energy Systems GmbH',
    location: 'Stockach',
    tagline: 'Ihre Experten für moderne Elektrotechnik',
    description: 'S.',
    stats: {
      projects: '500+',
      experience: '20+',
      customers: '1000+',
      employees: '15',
    },
  },

    heroSlides: [
    {
      id: 1,
      imageUrl: '/seo-assets/photovoltaik-installation-konstanz.jpg',
      alt: 'Photovoltaik-Installation auf einem Einfamilienhaus in Konstanz.',
      titleText: 'Photovoltaik & Speicher',
      headline: ['Photovoltaik,', 'die zum Gebäude passt.'],
      subline:
        'PV-Anlagen, Stromspeicher und Energiemanagement – sauber geplant, fachgerecht installiert und auf Ihr Gebäude abgestimmt.',
      cta: { label: 'PV-Projekt besprechen', targetId: 'contact' },
      secondaryCta: { label: 'Photovoltaik ansehen', targetPath: '/photovoltaik' },
      footerLine: 'companyName',
    },
    {
      id: 2,
      imageUrl: '/seo-assets/elektroverteilung-konstanz.jpg',
      alt: 'Elektriker installiert eine Elektroverteilung in Konstanz.',
      titleText: 'Elektrotechnik',
      headline: ['Elektrotechnik,', 'klar aufgebaut.'],
      subline:
        'Elektroinstallation, Verteilungen, Schutztechnik und Dokumentation für Wohn- und Gewerbeobjekte – strukturiert von der Planung bis zur Übergabe.',
      cta: { label: 'Elektro-Projekt starten', targetId: 'contact' },
      secondaryCta: { label: 'Leistungen ansehen', targetId: 'features' },
      footerLine: 'companyName',
    },
    {
      id: 3,
      imageUrl: '/seo-assets/pv-anlage-konstanz.jpg',
      alt: 'PV-Anlage als Referenzprojekt in Konstanz.',
      titleText: 'Referenzen',
      headline: ['Referenzen,', 'die Leistung zeigen.'],
      subline:
        'Reale Photovoltaik- und Elektro-Projekte mit klarer Planung, sauberer Umsetzung und stabilem Betrieb nach der Inbetriebnahme.',
      cta: { label: 'Referenzen ansehen', targetId: 'projects' },
      secondaryCta: { label: 'Kontakt aufnehmen', targetId: 'contact' },
      footerLine: 'companyName',
    },
    {
      id: 4,
      imageUrl: '/seo-assets/photovoltaik-montage-radolfzell.jpg',
      alt: 'Montage einer Photovoltaik-Anlage im Raum Radolfzell.',
      titleText: 'Planung & Montage',
      headline: ['Planung,', 'Montage, Übergabe.'],
      subline:
        'Von der ersten Beratung bis zur Inbetriebnahme begleitet EOS Photovoltaik, Speicher, Wallbox und Elektrotechnik als ein durchdachtes System.',
      cta: { label: 'Beratung anfragen', targetId: 'contact' },
      secondaryCta: { label: 'Ablauf ansehen', targetId: 'features' },
      footerLine: 'companyName',
    },
  ],

  serviceScenes: [
  {
    id: 'pv',
    eyebrow: '01 / Photovoltaik',
    title: 'Solarstrom, sauber geplant und stark umgesetzt.',
    text:
      'Von der ersten Einschätzung bis zur fertigen Anlage: EOS plant PV-Anlagen, Speicher und Energiemanagement passend zu Gebäude, Verbrauch und Erweiterbarkeit.',
    image: '/projekte/pv-dachanlage-schramberg.jpg',
    alt: 'Photovoltaik-Anlage auf einem Wohnhaus im Raum Konstanz.',
    stats: [
      ['PV', 'Erzeugung'],
      ['Speicher', 'Eigenverbrauch'],
      ['EMS', 'Steuerung'],
    ],
  },
  {
    id: 'elektrotechnik',
    eyebrow: '02 / Elektrotechnik & elektrische Systeme',
    title: 'Elektrische Systeme, sauber aufgebaut.',
    text:
      'Verteilungen, Schutztechnik und elektrische Infrastruktur werden so geplant und umgesetzt, dass Technik übersichtlich, sicher und langfristig betreibbar bleibt.',
    image: '/seo-assets/elektroinstallation-konstanz.jpg',
    alt: 'Elektroinstallation und Sicherungskasten durch Elektriker in Konstanz.',
    stats: [
      ['Verteilung', 'Struktur'],
      ['Schutz', 'Sicherheit'],
      ['System', 'Betrieb'],
    ],
  },
  {
    id: 'wallbox',
    eyebrow: '03 / Wallbox & Erweiterungen',
    title: 'Erweiterbar, wenn sich Bedarf ändert.',
    text:
      'Wallbox, Speicher, zusätzliche Stromkreise oder Erweiterungen der Verteilung werden so geplant, dass Bestand und neue Technik sauber zusammenspielen.',
    image: '/seo-assets/wallbox-installation-konstanz.jpg',
    alt: 'Wallbox-Installation durch Elektriker in Konstanz.',
    align: 'right',
    stats: [
      ['Wallbox', 'Laden'],
      ['Bestand', 'Erweitern'],
      ['Reserve', 'Planen'],
    ],
  },
  {
    id: 'dguv',
    eyebrow: '04 / DGUV Prüfung & Wartung',
    title: 'Prüfung, Wartung und Nachweis.',
    text:
      'DGUV-Prüfungen, Wartung, Messprotokolle und Dokumentation schaffen Sicherheit im Betrieb – nachvollziehbar, strukturiert und sauber übergeben.',
    image: '/seo-assets/dguv-pruefung-wartung.jpg',
    alt: 'DGUV-Prüfung und Wartung an einer elektrischen Verteilung.',
    stats: [
      ['DGUV', 'Prüfung'],
      ['Wartung', 'Betrieb'],
      ['Doku', 'Nachweis'],
    ],
  },
  ],

  referenceTiles: [
  {
    title: 'PV-Anlagen',
    text: 'Dachflächen, Speicher und Verbrauch werden als Gesamtsystem betrachtet.',
    image: '/seo-assets/photovoltaik-dachanlage-stockach.jpg',
  },
  {
    title: 'Elektrotechnik',
    text: 'Verteilungen, Schutztechnik und Dokumentation sauber aufgebaut.',
    image: '/seo-assets/dguv-pruefung-wartung.jpg',
  },
  {
    title: 'Erweiterungen',
    text: 'Wallbox, Speicher und neue Anforderungen sinnvoll nachrüsten.',
    image: '/seo-assets/wallbox-installation-konstanz.jpg',
    wide: true,
  },
  ],

  services: [
    {
      id: 1,
      title: 'Elektroinstallation für Alt- und Neubau',
      description:
        'Professionelle Elektroinstallationen für Wohn- und Gewerbeobjekte. Von der Planung bis zur Abnahme.',
      icon: 'Zap',
      image: '/seo-assets/elektroinstallation-konstanz.jpg',
      features: [
        'Hausinstallationen',
        'Gewerbeinstallationen',
        'Modernisierungen',
        'Störungsbehebung',
      ],
    },
    {
      id: 2,
      title: 'Photovoltaik (PV)',
      description:
        'Nachhaltige Energielösungen mit modernen Photovoltaikanlagen für maximale Effizienz.',
      icon: 'Sun',
      image: '/seo-assets/pv-anlage-konstanz.jpg',
      features: [
        'Anlagenplanung',
        'Installation',
        'Wartung',
        'Speichersysteme',
      ],
    },
    {
      id: 3,
      title: 'DGUV Prüfung',
      description:
        'Gesetzlich vorgeschriebene Prüfungen elektrischer Anlagen und Betriebsmittel.',
      icon: 'Shield',
      image:
        'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=800&h=600&fit=crop',
      features: ['E-Check', 'Anlagenprüfung', 'Geräteprüfung', 'Dokumentation'],
    },
    {
      id: 4,
      title: 'Sicherheitssysteme',
      description:
        'Moderne Sicherheitstechnik für optimalen Schutz Ihrer Räumlichkeiten.',
      icon: 'Lock',
      image:
        'https://images.unsplash.com/photo-1558494949-ef010cbdcc31?w=800&h=600&fit=crop',
      features: [
        'Videoüberwachung',
        'Alarmanlagen',
        'Zutrittskontrolle',
        'Brandmeldeanlagen',
      ],
    },
    {
      id: 5,
      title: 'Erweiterungen (Wallbox)',
      description:
        'Ladeinfrastruktur für Elektrofahrzeuge - zukunftsorientiert und effizient.',
      icon: 'Car',
      image:
        'https://images.unsplash.com/photo-1593941707882-a5bac6861d75?w=800&h=600&fit=crop',
      features: [
        'Wallbox Installation',
        'Lademanagement',
        'Smart Charging',
        'Wartung & Service',
      ],
    },
  ],

  projects: [
    {
      id: 1,
      title: 'Einfamilienhaus Stockach',
      headerdescription: 'Optimale Energieausbeute trotz Verschattung',
      description:
        'Seitliche Verschattungen werden durch den Einsatz von SolarEdge Leistungsoptimierern kompensiert. Jedes Modul arbeitet unabhängig, sodass auch teilverschattete Bereiche zur maximalen Energiegewinnung beitragen. Die Optimierer sichern eine hohe Gesamteffizienz der PV-Anlage selbst unter schwierigen Bedingungen.',
      images: ['/projekte/pv-anlage-stockach.jpg', '/projekte/pv-module-stockach.jpg'],
      highlights: [
        {
          heading: 'Größe PV-Anlage',
          text: '10.5kWp',
        },
        {
          heading: 'PV-Wechselrichter',
          text: 'SolarEdge',
        },
        {
          heading: 'Speicher',
          text: 'SolarEdge mit 14,55 kWh',
        },
        // beliebig viele weitere Stichpunkte
      ],
    },
    {
      id: 2,
      title: 'Mehrfamilienhaus Hüfingen',
      headerdescription: 'Intelligentes Energiemanagement',
      description:
        'Eine stufenlose Heizstabregelung sorgt bei PV-Überschuss für die Wassererwärmung. Durch den Einsatz des Fronius Ohmpilot wird überschüssige Sonnenenergie intelligent genutzt, um Warmwasser effizient und nachhaltig zu erzeugen.',
      images: [
        '/projekte/pv-anlage-huefingen.jpg',
        '/projekte/pv-dachanlage-huefingen.jpg',
        '/projekte/pv-dach-huefingen.jpg',
        '/projekte/pv-module-huefingen.jpg',
      ],
      highlights: [
        {
          heading: 'Größe PV-Anlage',
          text: '10.5kWp',
        },
        {
          heading: 'PV-Wechselrichter',
          text: 'Symo Gen24 10.0 plus',
        },
        {
          heading: 'Speicher',
          text: 'BYD Battery-Box Premium HVS 10.2 kWh',
        },
        // beliebig viele weitere Stichpunkte
      ],
    },
    {
      id: 3,
      title: 'Wallbox-Installation Singen',
      headerdescription: 'E-Mobilität',
      description:
        'Die Mennekes Wallbox überzeugt durch hochwertige Materialien, exzellente Verarbeitungsqualität und ein zeitloses, funktionales Design. Über die drei Tasten an der Front lassen sich die wichtigsten Lademodi ganz einfach auswählen – ob Überschussladen mit der PV-Anlage, unterstütztes Laden oder schnelles Laden bei Bedarf.',
      images: [
        '/projekte/wallbox-singen.jpg',
        '/projekte/wallbox-bedienfeld-singen.jpg',
        '/projekte/wallbox-installation-singen.jpg',
      ],
      highlights: [
        {
          heading: 'Hersteller',
          text: 'Mennekes',
        },
        {
          heading: 'Leistung',
          text: '11 kW',
        },
        {
          heading: 'Lademodus',
          text: 'PV-Überschuss',
        },
        // beliebig viele weitere Stichpunkte
      ],
    },
    {
      id: 4,
      title: 'Einfamilienhaus Schramberg',
      headerdescription: 'PV-Erweiterung für maximalen Eigenbedarf',
      description:
        'Die parallel errichtete PV-Erweiterungsanlage steigert gezielt den Eigenverbrauch. Überschüssige Solarenergie wird intelligent gesteuert und direkt vor Ort genutzt, während die bestehende Anlage weiterhin vollständig ins Netz einspeist. So lassen sich Stromkosten senken und die selbst erzeugte Energie effizient und nachhaltig einsetzen.',
      images: ['/projekte/pv-erweiterung-schramberg.jpg', '/projekte/pv-dachanlage-schramberg.jpg', '/projekte/pv-module-schramberg.jpg'],
      highlights: [
        {
          heading: 'Größe PV-Anlage',
          text: '4.5kWp',
        },
        {
          heading: 'PV-Wechselrichter',
          text: 'Sungrow Hybrid SH6.0RT',
        },
        {
          heading: 'Speicher',
          text: 'BYD Battery-Box Premium HVS 5.1 kWh',
        },
        // beliebig viele weitere Stichpunkte
      ],
    },
    {
      id: 5,
      title: 'Wallbox Stockach',
      headerdescription: 'Smart laden mit PV-Überschuss',
      description:
        'Eine Go Wallbox mit Controller ermöglicht intelligentes Laden passend zur PV-Anlage. Das System nutzt Solarstromüberschüsse automatisch und kann zusätzlich dynamische Stromtarife berücksichtigen, damit das Elektrofahrzeug besonders wirtschaftlich und netzdienlich geladen wird.',
      images: ['/projekte/wallbox-smart-laden-stockach.jpg', '/projekte/wallbox-controller-stockach.jpg'],
      highlights: [
        {
          heading: 'Hersteller',
          text: 'Go Wallbox',
        },
        {
          heading: 'Leistung',
          text: '11 kW',
        },
        {
          heading: 'Lademodus',
          text: 'PV-Überschuss & Tarif',
        },
      ],
    },
    {
      id: 6,
      title: 'Elektroinstallation Stockach',
      headerdescription: 'Installation mit Eigenleistung',
      description:
        'Bei diesem Projekt in Stockach wurde die Elektroinstallation so vorbereitet und begleitet, dass Eigenleistung des Kunden sinnvoll eingebunden werden konnte. Die Ausführung folgt den individuellen Wünschen vor Ort, bleibt fachlich sauber strukturiert und schafft eine sichere Grundlage für den weiteren Ausbau.',
      images: [
        '/projekte/elektroinstallation-stockach.jpg',
        '/projekte/elektroinstallation-eigenleistung.jpg',
        '/projekte/elektroinstallation-verteiler-vorbereitung.jpg',
      ],
      highlights: [
        {
          heading: 'Leistung',
          text: 'Elektroinstallation',
        },
        {
          heading: 'Ort',
          text: 'Stockach',
        },
        {
          heading: 'Umsetzung',
          text: 'mit Eigenleistung',
        },
      ],
    },
    {
      id: 7,
      title: 'PV-Anlage Neuhausen ob Eck',
      headerdescription: 'Photovoltaik auf Wohnhaus und Carport',
      description:
        'Die Kombination aus Photovoltaikanlage auf dem Wohnhaus und PV-Carport erschließt die verfügbaren Flächen optimal für eine leistungsstarke Eigenstromversorgung. Ergänzend wurde die elektrische Infrastruktur des Gebäudes modernisiert und eine 11-kW-Wallbox in das Gesamtsystem integriert. So entsteht eine abgestimmte Energielösung, bei der der erzeugte Solarstrom effizient im Gebäude genutzt und für das Laden des Elektrofahrzeugs eingesetzt werden kann.',
      images: [
        '/projekte/pv-dachanlage-carport-neuhausen.jpg',
        '/projekte/pv-anlage-carport-neuhausen.jpg',
        '/projekte/pv-carport-unterkonstruktion-neuhausen.jpg',
        '/projekte/pv-speicher-wechselrichter-neuhausen.jpg',
        '/projekte/zaehlerschrank-pv-anlage-neuhausen.jpg',
      ],
      imageAlts: [
        'Photovoltaik-Anlage auf Wohnhausdach und Carport in Neuhausen.',
        'Luftaufnahme einer PV-Anlage mit Solarmodulen auf Hausdach und Carport in Neuhausen.',
        'PV-Carport mit sichtbarer Unterkonstruktion und Solarmodulen in Neuhausen.',
        'PV-Speicher und Wechselrichtertechnik einer Photovoltaik-Anlage in Neuhausen.',
        'Zählerschrank der Photovoltaik-Anlage in Neuhausen.',
      ],
      highlights: [
        {
          heading: 'Leistung',
          text: '17,94 kWp',
        },
        {
          heading: 'PV-Wechselrichter',
          text: 'Kostal Plenticore G3 L',
        },
        {
          heading: 'Speicher',
          text: 'Pylotech 15,36 kWh',
        },
      ],
    },
  ],

  team: [
    {
      name: 'Thomas Müller',
      position: 'Geschäftsführer & Elektrotechnikermeister',
      experience: '20+ Jahre Erfahrung',
    },
    {
      name: 'Sandra Weber',
      position: 'Projektleiterin',
      experience: '15+ Jahre Erfahrung',
    },
    {
      name: 'Michael Schmidt',
      position: 'Elektrotechniker',
      experience: '10+ Jahre Erfahrung',
    },
  ],

  contact: {
    address: 'Blütenweg 10, 78357 Mühlingen',
    phone: '+49 151 6858 1912',
    email: 'info@eos-energy-systems.de',
    hours: 'Mo-Fr: 7:00-18:00 Uhr',
  },
};
